import ShadeSimpleView from './ShadeSimpleView'

export default ShadeSimpleView
